module.exports = __webpack_public_path__ + "static/media/artBio_syllabus.16dc0201.pdf";